import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label } from 'cw-ui-core';
import React, { useEffect } from 'react';
import layoutCss from 'src/styles/layout.scss';
import css from './DeleteApplicationDialog.scss';
import Locale from '../../../i18n';
import TextButton from '../../../components/TextButton';

export const DELETE_APPLICATION_DIALOG = 'DELETE_APPLICATION_DIALOG';

const DeleteApplicationDialog = ({ intl, onDidMount, onOk, onCancel }) => {
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const { formatMessage } = intl;

    const dialogButtons = [
        <TextButton key="ok" automationName="ok" text={formatMessage(Locale.delete)} onClick={onOk} />,
        <TextButton key="cancel" automationName="cancel" text={formatMessage(Locale.cancel)} onClick={onCancel} />,
    ];

    return (
        <Dialog
            dialogId={DELETE_APPLICATION_DIALOG}
            header={formatMessage(Locale.deleteApplication)}
            buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={DELETE_APPLICATION_DIALOG} />
                    <Label>{formatMessage(Locale.deleteApplicationConfirmation)}</Label>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(DeleteApplicationDialog);
